import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Icon } from "components/common";
import { Button, Input } from "components/bootstrap";
import { DATE_TIME_FORMATS } from "util/DateTime";
import useUserDateTime from "hooks/useUserDateTime";
const Wrapper = styled.div`
  width: 100%;

  .form-group {
    margin: 0;
  }
`;
const AbsoluteDateInput = ({
  name,
  disabled = false,
  onChange = () => {
  },
  value = "",
  hasError = false,
  className = void 0,
  label = void 0
}) => {
  const { t } = useTranslation("search");
  const { formatTime } = useUserDateTime();
  const _onSetTimeToNow = () => onChange(formatTime(/* @__PURE__ */ new Date(), "complete"));
  const _onChange = (event) => onChange(event.target.value);
  return /* @__PURE__ */ React.createElement(Wrapper, { className }, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: `date-input-${name}`,
      name,
      "aria-label": label,
      autoComplete: "off",
      disabled,
      onChange: _onChange,
      placeholder: DATE_TIME_FORMATS.default,
      value,
      buttonAfter: /* @__PURE__ */ React.createElement(Button, { disabled, onClick: _onSetTimeToNow, title: t("time_range.insert_current_date") }, /* @__PURE__ */ React.createElement(Icon, { name: "calendar_clock" })),
      className: "mousetrap",
      bsStyle: hasError ? "error" : null
    }
  ));
};
export default AbsoluteDateInput;
